'use strict';

class OperativeSpendingsController {
    /* @ngInject */
    constructor(
        OperativeSpendingsService,
        QuotesService,
        VehiclesService,
        EmployeesService,
        WorkersService,
        VouchersService,
        OrderTranslationService,
        $scope,
        $stateParams
    ) {
        Object.assign(this, {
            OperativeSpendingsService,
            QuotesService,
            VehiclesService,
            EmployeesService,
            WorkersService,
            VouchersService,
            OrderTranslationService,
            $scope,
            $stateParams
        });

        this.query = {
            include: [
                'employee',
                'holder',
                'vehicle',
                'quote',
                'collection'
            ],
            where: {},
            limit: 10,
            page: 1,
            order: 'createdAt DESC',
            deleted: true
        };

        if (this.$stateParams.quoteId) {
            let quoteId = parseInt(this.$stateParams.quoteId, 10);
            if (!isNaN(quoteId)) {
                this.quoteId = quoteId;
            }
        }

        this.getModels();

        this.onPagination = () => {
            this.getModels();
        };

        this.onReorder = () => {
            this.getModels();
        };
    }

    getModels() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.quoteId) {
            return this.QuotesService.findById(this.quoteId).then(quote => {
                // FIXME: won't be affected by mdOrder
                qOpts.where =  {
                    or: [
                        { quoteId: this.quoteId },
                        { vehicleId: quote.vehicleId },
                        { holderId: quote.holderId }
                    ]
                };
                qOpts.deletedAt = true;

                let queryReady = this
                    .OperativeSpendingsService.getModels(qOpts)
                    .then(spendings => {
                        this.spendings = spendings;
                        this.updateTotal();
                    });
                let countReady = this
                    .OperativeSpendingsService.getCount(qOpts)
                    .then(result => {
                        this.operativeSpendingsCount = result.count;
                    });
                this.promise = this.$q.all([queryReady, countReady]);
                return this.promise;
            });
        }

        if (this.operativeSpendingId) {
            this.vehicle = null;
            this.employee = null;
            this.worker = null;
            Object.assign(qOpts.where, {
                id: this.operativeSpendingId
            });
        }

        if (this.voucherId) {
            this.vehicle = null;
            this.employee = null;
            this.worker = null;
            Object.assign(qOpts.where, {
                voucherId: this.voucherId
            });
        }

        if (this.vehicle) {
            Object.assign(qOpts.where, {
                vehicleId: this.vehicle.id
            });
        }
        if (this.employee) {
            Object.assign(qOpts.where, {
                employeeId: this.employee.id
            });
        }
        if (this.quoteIds) {
            Object.assign(qOpts.where, {
                quoteId: {
                    inq: this.quoteIds
                }
            });
        }
        if (this.voucherIds) {
            Object.assign(qOpts.where, {
                voucherId: {
                    inq: this.voucherIds
                }
            });
        }
        if (this.onlyNonAssociated) {
            Object.assign(qOpts.where, {
                associatedAt: null
            });
        }
        if (this.amount) {
            Object.assign(qOpts.where, {
                amount: {
                    gt: this.amount
                }
            });
        }
        if (this.mdOrder) {
            qOpts.order = this.OrderTranslationService.translate(
                this.mdOrder
            );
        }

        let queryReady = this.OperativeSpendingsService
            .getModels(qOpts)
            .then(spendings => {
                this.spendings = spendings;
                this.updateTotal();
            });
        let countReady = this.OperativeSpendingsService
            .getCount(qOpts)
            .then(result => {
                this.operativeSpendingsCount = result.count;
            });
        return Promise.all([queryReady, countReady]);
    }

    updateTotal() {
        this.total = this.spendings
            .filter(s => !s.deletedAt)
            .reduce((sum, s) => sum + s.amount, 0);
    }

    onHolderFilterUpdate($event) {
        let clientsPromise = $event.clientsPromise;
        clientsPromise.then(clients => {
            if (clients) {
                return this.QuotesService.find({
                    filter: {
                        where: {
                            holderId: {
                                inq: clients.map(c => c.id)
                            }
                        }
                    }
                }).then(quotes => {
                    this.quoteIds = quotes.map(q => q.id);
                });
            } else {
                this.quoteIds = null;
            }
        }).then(() => { this.getModels(); });
    }

    queryVehicleSearch() {
        return this.VehiclesService.getModels({
            where: {
                broad: this.searchVehicleText
            },
            order: 'plate DESC, number DESC, description DESC'
        });
    }

    queryEmployeeSearch() {
        return this.EmployeesService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchEmployeeText}/i`
                    }
                }
            }
        });
    }

    queryWorkerSearch() {
        return this.WorkersService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchWorkerText}/i`
                    }
                }
            }
        });
    }

    getVehicleShortLabel(v) {
        return v ? v.plate || v.number || v.description : '';
    }

    getVehicleFullLabel(v) {
        return `${v.plate || ''} - ${v.number || ''} - ${v.description || ''}`;
    }

    onWorkerChange() {
        Promise.resolve().then(() => {
            if (this.worker) {
                return this.VouchersService.find({
                    filter: {
                        where: {
                            workerId: this.worker.id
                        }
                    }
                }).then(vouchers => {
                    this.voucherIds = vouchers.map(v => v.id);
                });
            } else {
                this.voucherIds = null;
            }
        }).then(() => { this.getModels(); });
    }
}

export default OperativeSpendingsController;
